// Détection d'exécution en iframe (ex. onglet intégré dans le panneau Navixy)
export const isEmbedded = (() => {
  try { return window.self !== window.top; } catch { return true; }
})();
